import {Stack, Table, TableBody, TableContainer, Typography} from "@mui/material";
import {useBaselineOverviewContext} from "../BaselineOverviewProvider";
import {useTranslation} from "react-i18next";
import {BaselineTableRow} from "../baselineTableRow/BaselineTableRow";
import {Project_Bss_Data_Type_Enum} from "../../../lib";

type CropsTableOverviewProductionProps = {
    seasonId: string
}

export function CropsTableOverviewProduction({seasonId}: CropsTableOverviewProductionProps) {
    const {cropsBySeason} = useBaselineOverviewContext();
    const {t} = useTranslation();
    const productionData = cropsBySeason[seasonId]?.[Project_Bss_Data_Type_Enum.CropsProduction] ?? {}
    return (
        <Stack spacing={2}>
            <Typography variant={'subtitle2'}>
                {t('crops.production')}
            </Typography>
            <TableContainer>
                <Table size={'small'} padding={'checkbox'}>
                    <TableBody>
                        {Object.keys(productionData).map((key, index) => {
                            const {data, term} = productionData[key]
                            return (
                                <BaselineTableRow type={Project_Bss_Data_Type_Enum.CropsProduction}
                                                  term={term}
                                                  isEven={index % 2 === 0}
                                                  data={data}
                                                  seasonId={seasonId}
                                                  key={key}
                                />
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Stack>
    )
}